const QURAN_UI_LABELS = {
  fr: {
    settings: "Parametres",
    display: "Affichage",
    theme: "Theme",
    light: "Clair",
    dark: "Sombre",
    language: "Langue d'interface",
    verseFontSize: "Taille des versets",
    close: "Fermer",
    search: "Recherche",
    chapterList: "Liste des sourates",
    chapterListTitle: "Index",
    chapterLabel: "Sourate",
    translation: "Traduction",
    recitation: "Recitation",
    tafsir: "Tafsir",
    loadingPage: "Chargement page...",
    loading: "Chargement...",
    noResults: "Aucun resultat.",
    searchInProgress: "Recherche en cours...",
    versesCount: "Versets",
    verse: "Verset",
    verseArabic: "Verset en arabe",
    book: "Livre",
    reader: "Lecteur",
    mode: "Mode",
    thisVerse: "Ce verset",
    untilEndSurah: "Jusqu'a fin sourate",
    launchRecitation: "Lancer recitation",
    chooseReader: "Choisir lecteur",
    noBook: "Aucun livre",
    chooseBook: "Choisir un livre",
    noReader: "Aucun lecteur",
    chooseReaderShort: "Choisir un lecteur",
    noTafsir: "Aucun tafsir",
    chooseTafsir: "Choisir un tafsir",
    recitationChapterHint: "La lecture enchainera automatiquement jusqu'a la fin de la sourate.",
    recitationAyahHint: "Lecture du verset selectionne uniquement.",
    translationLoadError: "Impossible de charger la traduction.",
    searchError: "Erreur pendant la recherche.",
    noTafsirForLanguage: "Aucun tafsir disponible pour la langue",
    tafsirLoadError: "Impossible de charger le tafsir.",
    startPlayback: "Lancer la lecture",
    pagePrevious: "Page precedente",
    pageNext: "Page suivante",
    quickPageScroll: "Defilement rapide pages",
    nextPage: "Page suivante",
    prevPage: "Page precedente",
    hideAudioDock: "Masquer le bloc audio",
    hide: "Masquer",
    stop: "Arreter",
    audioProgress: "Progression audio",
    previous: "Precedent",
    next: "Suivant",
    play: "Lecture",
    pause: "Pause",
    speed: "Vitesse",
    juz: "Juz",
    surahWord: "Sourate",
    pageWord: "Page",
    ayahWord: "Aya",
  },
  en: {
    settings: "Settings",
    display: "Display",
    theme: "Theme",
    light: "Light",
    dark: "Dark",
    language: "Interface language",
    verseFontSize: "Verse font size",
    close: "Close",
    search: "Search",
    chapterList: "Surah list",
    chapterListTitle: "Index",
    chapterLabel: "Surah",
    translation: "Translation",
    recitation: "Recitation",
    tafsir: "Tafsir",
    loadingPage: "Loading page...",
    loading: "Loading...",
    noResults: "No results.",
    searchInProgress: "Searching...",
    versesCount: "Verses",
    verse: "Verse",
    verseArabic: "Arabic verse",
    book: "Book",
    reader: "Reader",
    mode: "Mode",
    thisVerse: "This verse",
    untilEndSurah: "Until end of surah",
    launchRecitation: "Start recitation",
    chooseReader: "Choose reader",
    noBook: "No book",
    chooseBook: "Choose a book",
    noReader: "No reader",
    chooseReaderShort: "Choose a reader",
    noTafsir: "No tafsir",
    chooseTafsir: "Choose tafsir",
    recitationChapterHint: "Playback will continue automatically to the end of the surah.",
    recitationAyahHint: "Playback of selected verse only.",
    translationLoadError: "Unable to load translation.",
    searchError: "Search failed.",
    noTafsirForLanguage: "No tafsir available for language",
    tafsirLoadError: "Unable to load tafsir.",
    startPlayback: "Start playback",
    pagePrevious: "Previous page",
    pageNext: "Next page",
    quickPageScroll: "Quick page scroll",
    nextPage: "Next page",
    prevPage: "Previous page",
    hideAudioDock: "Hide audio panel",
    hide: "Hide",
    stop: "Stop",
    audioProgress: "Audio progress",
    previous: "Previous",
    next: "Next",
    play: "Play",
    pause: "Pause",
    speed: "Speed",
    juz: "Juz",
    surahWord: "Surah",
    pageWord: "Page",
    ayahWord: "Ayah",
  },
  ar: {
    settings: "الاعدادات",
    display: "العرض",
    theme: "السمة",
    light: "فاتح",
    dark: "داكن",
    language: "لغة الواجهة",
    verseFontSize: "حجم خط الآيات",
    close: "اغلاق",
    search: "بحث",
    chapterList: "قائمة السور",
    chapterListTitle: "الفهرس",
    chapterLabel: "سورة",
    translation: "ترجمة",
    recitation: "تلاوة",
    tafsir: "تفسير",
    loadingPage: "جاري تحميل الصفحة...",
    loading: "جاري التحميل...",
    noResults: "لا توجد نتائج.",
    searchInProgress: "جاري البحث...",
    versesCount: "الآيات",
    verse: "الآية",
    verseArabic: "الآية بالعربية",
    book: "الكتاب",
    reader: "القارئ",
    mode: "الوضع",
    thisVerse: "هذه الآية",
    untilEndSurah: "حتى نهاية السورة",
    launchRecitation: "بدء التلاوة",
    chooseReader: "اختيار القارئ",
    noBook: "لا يوجد كتاب",
    chooseBook: "اختر كتابا",
    noReader: "لا يوجد قارئ",
    chooseReaderShort: "اختر قارئا",
    noTafsir: "لا يوجد تفسير",
    chooseTafsir: "اختر تفسيرا",
    recitationChapterHint: "ستستمر التلاوة تلقائيا حتى نهاية السورة.",
    recitationAyahHint: "تلاوة الآية المحددة فقط.",
    translationLoadError: "تعذر تحميل الترجمة.",
    searchError: "حدث خطأ أثناء البحث.",
    noTafsirForLanguage: "لا يوجد تفسير متاح للغة",
    tafsirLoadError: "تعذر تحميل التفسير.",
    startPlayback: "بدء التشغيل",
    pagePrevious: "الصفحة السابقة",
    pageNext: "الصفحة التالية",
    quickPageScroll: "تنقل سريع بين الصفحات",
    nextPage: "الصفحة التالية",
    prevPage: "الصفحة السابقة",
    hideAudioDock: "اخفاء لوحة الصوت",
    hide: "اخفاء",
    stop: "ايقاف",
    audioProgress: "تقدم الصوت",
    previous: "السابق",
    next: "التالي",
    play: "تشغيل",
    pause: "ايقاف مؤقت",
    speed: "السرعة",
    juz: "الجزء",
    surahWord: "سورة",
    pageWord: "الصفحة",
    ayahWord: "آية",
  },
};

export default QURAN_UI_LABELS;
